<template>
  <div class="flex act-container">
    <div>
      <act-preview
        :navigationBg="ruleForm.gameBgc"
        phoneHeaderFixedColor="#fff"
        :navigationTitle="ruleForm.gameName"
      >
      <div :style="{backgroundColor:ruleForm.gameBgc}">
        <img
          :src="ruleForm.gameBgp"
          style="width: 375px; height: 177px"
          v-if="ruleForm.gameBgp"
        />
        <div class="part01">
          <div class="title flex flex-center item-center">
              {{ ruleForm.gameBgp6 }}
              <span class="tips">距您最近</span>
            </div>
            <div class="content flex flex-column item-center">
              <img
                class="customerQrcode"
                :src="ruleForm.gameBgp5"
              />
              <div class="tips">[长按识别]二维码添加店长进群</div>
            </div>
        </div>
        <div class="part02">
            <div class="modal-search-wrapper flex flex-1">
              <input
                class="hm-input"
                type="text"
                v-model.trim="word"
                :placeholder="placeholder"
                :disabled="true"
              />
              <span class="iconfont search icon-sousuo"></span>
            </div>
            <div class="location flex flex-between">
              <div class="flex item-center">
                <span :style="{ color: ruleForm.gameBgc }" class="iconfont icon-dizhi1">
                </span>
                <div class="address">{{ currentAddress }}</div>
              </div>
              <div class="flex item-center">
                <img
                  class="location-icon"
                  :src="iconLocation"
                  mode="widthFix"
                />
                <div class="location-text" :style="{ color: ruleForm.gameBgc }">
                  重新定位
                </div>
              </div>
            </div>
            <div class="shop-list">
              <div
                class="item flex flex-between item-center"
                v-for="(v, i) in ruleForm.storeGameShopRelModelList"
                :key="i"
              >
                <div class="content flex-1">
                  <div class="title flex item-center">
                    <div class="title-text">
                      {{ v.shopName }}
                    </div>
                    <div class="distance flex-1">
                      距您XXKM
                    </div>
                  </div>
                  <div class="address" v-if="v.shopAddress">
                    {{ v.shopAddress }}{{v.shopDetailAddress}}
                  </div>
                </div>
                <div>
                  <button class="btn round btn02" v-if="false">
                    当前选择
                  </button>
                  <button
                    class="btn round btn01"
                    :style="{ backgroundColor: ruleForm.gameBgc }"
                    v-else
                  >
                    加群
                  </button>
                </div>
              </div>
            </div>
        </div>
      </div>  
      </act-preview>
    </div>
    <div class="add-goods-containers">
      <div class="act-step-wrapper">
        <hm-step
          :steps="steps"
          :scroll="true"
          :step="currentStep"
          @scroll="windowScroll"
        ></hm-step>
      </div>
      <div class="act-wrapper">
        <el-scrollbar :style="{ height: scrollHeight + 'px' }">
          <div class="pvw flex flex-wrap">
            <div class="flex-4">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="170px"
              >
                <div id="base">1.基本信息</div>
                <el-form-item label="活码名称" prop="gameTitle">
                  <el-input
                    maxlength="20"
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.gameTitle"
                    placeholder="请输入活码名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="活动标题" prop="gameName">
                  <el-input
                    maxlength="20"
                    style="width: 400px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.gameName"
                    placeholder="请输入活动标题"
                  ></el-input>
                </el-form-item>
                <el-form-item label="主图：" prop="mainImgUrl">
                  <my-upload
                    field="file"
                    @crop-success="cropSuccess"
                    @crop-upload-success="cropUploadSuccess"
                    @crop-upload-fail="cropUploadFail"
                    v-model="show"
                    v-if="show"
                    noCircle
                    noSquare
                    :width="750"
                    :height="350"
                    :headers="{ 'X-Access-Token': $token }"
                    :params="{ fileDir: 'mallDecoration' }"
                    :url="$uploadUrl"
                    img-format="png"
                  ></my-upload>
                  <el-button
                    type="primary"
                    size="small"
                    v-show="!ruleForm.gameBgp"
                    @click="toggleShow"
                    >上传</el-button
                  >
                  <span class="form-tip"
                    >图片尺寸建议750x350（最多上传一张）</span
                  >
                  <div class="priview" v-if="ruleForm.gameBgp">
                    <img :src="ruleForm.gameBgp" alt="主图" />
                    <div class="opreat-wrapper flex item-center flex-center">
                      <el-button type="text" @click="handleRemove"
                        >删除</el-button
                      >
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="背景色:" prop="gameBgc">
                  <el-color-picker
                    v-model="ruleForm.gameBgc"
                    size="mini"
                  ></el-color-picker>
                </el-form-item>

                <div class="mt40" id="gameRule">
                  {{ steps.length === 3 ? 2 : 2 }}选择活码
                </div>

                <el-form-item label="" prop="drawTypeList">
                  <div class="flex batch flex-between item-center">
                    <div>
                      <el-button
                        size="small"
                        type="primary"
                        @click="batchSetting"
                        >新增二维码
                      </el-button>
                    </div>
                  </div>
                  <el-table
                    :data="ruleForm.storeGameShopRelModelList"
                    row-key="wxshopSkuId"
                    border
                    class="mt10"
                    stripe
                    max-height="400"
                    style="width: 100%"
                    :header-cell-style="{
                      background: '#f7f7f7',
                      color: '#606266',
                    }"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      type="index"
                      label="序号"
                      width="50"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="商店名称"
                      prop="shopName"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="自定义简称"
                      prop="customName"
                    >
                      <template slot-scope="scope">
                        <el-form-item>
                          <el-input
                            placeholder="请输入自定义简称"
                            size="small"
                            v-model="scope.row.customName"
                          ></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="所在省市区"
                      prop="citys"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="定位地址"
                      prop="shopAddress"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.shopAddress
                        }}{{ scope.row.shopDetailAddress }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="二维码"
                      prop="customerQrcode"
                    >
                      <template slot-scope="scope">
                        <div class="flex flex-center">
                          <div
                            class="flex goods-upload-btn"
                            @click="
                              addGoodsImg(
                                scope.row,
                                scope.$index,
                                'customerQrcode'
                              )
                            "
                            v-if="!scope.row.customerQrcode"
                          >
                            <div
                              style="margin-left: 0px"
                              class="btn flex flex-column flex-center open-file item-center"
                            >
                              <div class="add-prize-img-wrapper">
                                <span class="hmicon icon-hao pointer"></span>
                              </div>
                              <span>添加图片</span>
                            </div>
                          </div>
                          <div v-else class="mr10 flex item-end priviews">
                            <el-image
                              class="img"
                              :src="scope.row.customerQrcode"
                              alt="logo"
                              :preview-src-list="[scope.row.customerQrcode]"
                            />
                            <div
                              class="opreat-wrapper flex item-center flex-center"
                            >
                              <el-button
                                type="text"
                                @click="handleRemoves(scope.$index)"
                                >删除</el-button
                              >
                            </div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      label="操作"
                      width="80px"
                    >
                      <template slot-scope="scope">
                        <el-button
                          @click="deleteAppend(scope.$index)"
                          type="text"
                          size="mini"
                          >删除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>

                <el-form-item label="未识别到位置的用户扫码" prop="gameBgp5">
                  <div class="form-tips">未获取到位置的客户推荐扫以下码:</div>
                  <div class="flex item-center">
                    <div
                      class="flex goods-upload-btn"
                      @click="addGoodsImg('', '', 'gameBgp5')"
                      v-if="!ruleForm.gameBgp5"
                    >
                      <div
                        style="margin-left: 0px"
                        class="btn flex flex-column flex-center open-file item-center"
                      >
                        <div class="add-prize-img-wrapper">
                          <span class="hmicon icon-hao pointer"></span>
                        </div>
                        <span>添加图片</span>
                      </div>
                    </div>
                    <div v-else class="mr10 flex item-end priviews">
                      <el-image
                        class="img"
                        :src="ruleForm.gameBgp5"
                        alt="logo"
                        :preview-src-list="[ruleForm.gameBgp5]"
                      />
                      <div class="opreat-wrapper flex item-center flex-center">
                        <el-button type="text" @click="handleRemoveGameBgp5()"
                          >删除</el-button
                        >
                      </div>
                    </div>
                    <div>
                      <el-input
                        maxlength="25"
                        style="width: 400px"
                        size="small"
                        clearable
                        class="ml20 ipt"
                        v-model.trim="ruleForm.gameBgp6"
                        placeholder="请输入默认门店名称"
                      ></el-input>
                    </div>
                  </div>
                </el-form-item>

                <div class="flex flex-center">
                  <el-button
                    type="primary"
                    size="small"
                    @click="submitForm('ruleForm')"
                    >发布
                  </el-button>
                  <el-button size="small" @click="$router.back(-1)"
                    >返回
                  </el-button>
                </div>
              </el-form>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <my-upload
      field="file"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="myUploadImg"
      v-if="myUploadImg"
      noCircle
      noSquare
      :width="250"
      :height="250"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsCenter' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
    <hm-filter-shop-list
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      @saveShops="saveShops"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-shop-list>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import { arrayUnique2 } from "@/utils/utils";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";
import area from "@/utils/area";

import XLSX from "xlsx";
import HmFilterShopList from "@/components/HmFilterShopList";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor,
    HmFilterShopList,
    actPreview,
  },
  data() {
    const patterndMainImgUrlFunc = function (rule, val, callback) {
      if (!this.ruleForm.gameBgp) {
        return callback(new Error("请选择主图"));
      }
      callback();
    }.bind(this);
    const gameBgp5Func = function (rule, val, callback) {
      if (!this.ruleForm.gameBgp5) {
        return callback(new Error("请选择默认门店"));
      }
      if(!this.ruleForm.gameBgp6){
        return callback(new Error("请输入默认门店名称"));
      }
      callback();
    }.bind(this);
    // const customerQrcodeFunc = function (rule, val, callback) {
    //   if (!this.ruleForm.storeGameShopRelModelList.length) {
    //     return callback(new Error("请新增二维码"));
    //   }
    //   callback();
    // }.bind(this);


    return {
      isRadio: false,
      dialogVisible: false,
      ruleForm: {
        gameType: "qr_code_shop",
        gameName: "",
        gameTitle: "",
        gameBgp:
          "https://imgcdn.hemiao100.com/hemiaoBase/hmService/gameBgp.png",
        gameBgc: "#E50065",
        gameBgp5: "",
        gameBgp6: "",
        storeGameShopRelModelList: [],
        storeGameQrcodeChannelInfoModelList: [
          {
            channelName: "",
          },
        ],
      },
      currentStep: 2,
      scrollHeight: 0,
      show: false,
      steps: [
        {
          id: "IntelligentCodeType",
          name: "选择活码类型",
        },
        {
          id: "IntelligentCodeDetail",
          name: "配置活码内容",
        },
        {
          id: "over",
          name: "设置完成",
        },
      ],
      rules: {
        gameTitle: [
          {
            required: true,
            message: "请输入活码名称",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patterndMainImgUrlFunc,
            trigger: "blur",
          },
        ],
        gameBgc:[{
            required: true,
            message: "请选择背景颜色",
            trigger: "change",
        }],
        // customerQrcode: [
        //   {
        //     required: true,
        //     validator: customerQrcodeFunc,
        //     trigger: "blur",
        //   },
        // ],
        gameBgp5: [
          {
            required: true,
            validator: gameBgp5Func,
            trigger: "blur",
          },
        ],
      },
      currentPage: 1,
      pageSize: 10,
      selectedShops: [],
      currentRow: {},
      myUploadImg: false,
      uploadType: "",
      currentShopIndex: 0,
      area,
      propCitys: {
        value: "value",
        children: "children",
      },
      word: "",
      placeholder: "请输入关键字搜索",
      currentAddress: "用户地址",
      iconLocation:
        "https://imgcdn.hemiao100.com/hemiaoBase/activity/location.png",
    };
  },
  computed: mapGetters(["storeStyle", "microShopStoreList", "virtualGoods"]),
  watch: {},
  created() {},
  mounted() {
    // window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.calcHeight();
    this.$store.dispatch("queryStoreStyle");
    if(this.$route.query.gameType){
      this.gameType = this.$route.query.gameType;
    }    
    if (this.$route.query.gameId) {
      this.activityDetail().then((res) => {
        console.log("res:", res.result);
        let result = res.result;
        this.ruleForm = result;
        this.ruleForm.storeGameShopRelModelList.forEach(v=>{
          v.citys = v.provinceName + v.cityName + v.districtName;
        })
      });
    }
  },
  destroyed: function () {
    // window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    activityDetail() {
      const { gameId } = this.$route.query;
      const params = {
        gameId,
      };
      return this.$store.dispatch("queryActivitDetail", params);
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.uploadType === "customerQrcode") {
        this.myUploadImg = false;
        this.ruleForm.storeGameShopRelModelList[
          this.currentShopIndex
        ].customerQrcode = jsonData.result;
        this.ruleForm.storeGameShopRelModelList = JSON.parse(
          JSON.stringify(this.ruleForm.storeGameShopRelModelList)
        );
        console.log(
          "this.ruleForm.storeGameShopRelModelList: ",
          this.ruleForm.storeGameShopRelModelList
        );
        return;
      } else if (this.uploadType === "gameBgp5") {
        this.ruleForm.gameBgp5 = jsonData.result;
        return;
      } else if (this.show) {
        this.ruleForm.gameBgp = jsonData.result;
      }
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    // handleScroll(e) {
    //   this.steps.map((v, i) => {
    //     const ele = document.getElementById(v.id);
    //     if (ele) {
    //       const offsetTop = ele.offsetTop;
    //       if (e.target.scrollTop + 360 > offsetTop) {
    //         this.currentStep = i + 1;
    //       } else {
    //         this.currentStep = i - 1 <= 0 ? 1 : i - 1;
    //       }
    //     }
    //   });
    // },
    submitForm(formName) {
      let params;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.storeGameShopRelModelList.length) {
            this.$message({
              message: "请新增二维码!",
              type: "warning"
            });
            return;
          }
          console.log("this.ruleForm", this.ruleForm);
          this.ruleForm.storeGameQrcodeChannelInfoModelList[0].channelName = this.ruleForm.gameTitle;
          this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
          params = this.ruleForm;
          console.log("params", params);
          let url;
          if(this.$route.query.gameId){
            params.gameId = this.$route.query.gameId;
            url = "editActivity";
          }else{
            url = "saveGameInfo"
          }
          this.$store.dispatch(url, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$router.push({
                name: "IntelligentCodeList",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    handleRemove() {
      this.ruleForm.gameBgp = "";
    },
    handleRemoves(index) {
      this.$set(
        this.ruleForm.storeGameShopRelModelList[index],
        "customerQrcode",
        ""
      );
    },
    handleRemoveGameBgp5() {
      this.ruleForm.gameBgp5 = "";
    },
    batchSetting() {
      this.dialogVisible = true;
    },
    deleteAppend(index) {
      this.ruleForm.storeGameShopRelModelList.splice(index, 1);
    },
    addGoodsImg(v, index, type) {
      this.uploadType = type;
      this.myUploadImg = !this.myUploadImg;
      this.currentShopIndex = index;
    },
    saveShops(data) {
      if (data.length > 0) {
        this.dialogVisible = false;
        this.ruleForm.storeGameShopRelModelList.push(...data);
        this.ruleForm.storeGameShopRelModelList = arrayUnique2(
          this.ruleForm.storeGameShopRelModelList,
          "shopId"
        );
        this.ruleForm.storeGameShopRelModelList.forEach((v) => {
          console.log('v.customerQrcode')
          v.customerQrcode = v.customerQrcode || v.qrCode;
          v.citys = v.shopProvinceName + v.shopCityName + v.shopDistrictName;
        });
        this.ruleForm.storeGameShopRelModelList = JSON.parse(JSON.stringify(this.ruleForm.storeGameShopRelModelList));
        console.log(
          "this.ruleForm.storeGameShopRelModelList:",
          this.ruleForm.storeGameShopRelModelList
        );
      } else {
        this.$message({
          message: "请选择商店",
          type: "warning",
        });
      }
    },
    setLink(row) {
      this.dialogVisible = false;
      this.isRadio = false;
    },
  },
};
</script>
<style lang="scss">
.add-goods-containers {
  width: 1200px;
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .step-wrapper {
    border-bottom: 1px solid #ddd;
  }

  .btn {
    margin-left: 10px;

    .hmicon {
      font-size: 12px;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.priview {
  position: relative;
  width: 380px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;

  img {
    width: 100%;
    height: 100%;
  }

  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;

  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }

  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
}

.goods-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}
.add-prize-img-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  user-select: none;
  .hmicon {
    font-size: 14px;
    margin-right: 0px;
  }
}
.priviews {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.part01 {
    width: 345px;
    border-radius: 6px;
    background: #ffffff;
    padding-bottom: 15px;
    margin: 0 auto;
    .title {
      height: 35px;
      font-size: 15px;
      color: #2b2b2b;
      background: #f5f5f5;
      font-weight: bold;
      border-radius: 6px 6px 0 0;
      .tips {
        padding: 0 5px;
        background: rgba(229, 52, 90, 0.1);
        border-radius: 23px;
        height: 14px;
        color: #e63559;
        font-size: 10px;
        margin-left: 5px;
      }
    }
    .content {
      .customerQrcode {
        width: 125px;
        height: 125px;
        border-radius: 2px;
        margin-top: 20px;
      }
      .tips {
        width: 228px;
        height: 28px;
        background: rgba(229, 50, 91, 0.1);
        border-radius: 30px;
        color: #e5325b;
        font-size: 13px;
        line-height: 28px;
        margin-top: 15px;
        text-align: center;
      }
    }
  }
  .part02 {
    width: 315px;
    padding: 15px;
    background: #ffffff;
    margin: 0 auto;
    margin-top: 10px;
    border-radius: 6px;
    .modal-search-wrapper {
      position: relative;
      margin-bottom: 18px;
      margin-top: 10px;
      .hm-input {
        background: #f0f0f0;
        border-radius: 30px;
        height: 34px;
        line-height: 34px;
        width: 100%;
        padding-left: 15px;
        padding-right: 45px;
      }

      .search {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
      }

      .clear {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
      }
    }
    .location {
      .address {
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .location-icon {
        width: 15px;
        height: 15px;
      }
      .location-text {
        font-size: 14px;
      }
    }
    .shop-list {
      padding-bottom: 30px;
      .item {
        padding: 15px 0 10px 0;
        border-bottom: solid 1px #cccccc;
        .content {
          width: 225px;
          padding-right: 5px;
          .title {
            .title-text {
              font-size: 14px;
              color: #2b2b2b;
              height: 20px;
              line-height: 20px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 150px;
            }
            .distance {
              font-size: 10px;
              color: #ffabc0;
              margin-left: 5px;
            }
          }
          .address {
            font-size: 10px;
            color: #8e8e8e;
            margin-top: 5px;
          }
        }
        .btn01 {
          width: 58px;
          height: 25px;
          line-height: 25px;
          border-radius: 27px;
          margin: 0;
          text-align: center;
          font-size: 14px;
          color: #ffffff;
        }
        .btn02 {
          width: 86px;
          height: 25px;
          line-height: 25px;
          background: #f4f4f4;
          border-radius: 27px;
          margin: 0;
          text-align: center;
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }
</style>
